import { createApi } from '@reduxjs/toolkit/query/react';
import AppEnvironment from '../../environment/app-environment';
import { selexpApiBaseQuery } from './selexp-api-base-query';

export const selexpPerformanceApiDuck = createApi({
  reducerPath: 'APISelexpPerformance',
  baseQuery: (args, api, extraOptions) => selexpApiBaseQuery(args, { ...api, endpoint: AppEnvironment.selexpPerformanceEndpoint! }, extraOptions),
  endpoints: () => ({}),
  keepUnusedDataFor: 3600, // 1 hour
});
